import { render, staticRenderFns } from "./UserAssignmentForm.vue?vue&type=template&id=7488b254"
import script from "./UserAssignmentForm.vue?vue&type=script&lang=js"
export * from "./UserAssignmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports